import styles from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { ActionIcon } from '@mantine/core';
export const ChatButton: React.FC = () => {
  const {
    setOpenModal
  } = useModalAction();
  return <ActionIcon size="input-md" hiddenFrom="xl" classNames={{
    root: styles.btnIcon
  }} onClick={() => setOpenModal(MODAL.CHAT)}>
      <Icons className="icon-pr-flat-chat-bubble" fontSize={24} />
    </ActionIcon>;
};